import addCourseCoupon from '@services/api/course/addCourseCoupon'
import addCourseLecture from '@services/api/course/addCourseLecture'
import addCourseSection from '@services/api/course/addCourseSection'
import createCourse from '@services//api/course/createCourse'
import createCourseLectureResource from '@services/api/course/createCourseLectureResource'
import createCoursePricingPolicy from '@services/api/course/createCoursePricingPolicy'
import createCourseTextContent from '@services/api/course/createCourseTextContent'
import createCourseVideoContent from '@services/api/course/createCourseVideoContent'
import deleteCourseCoupons from '@services/api/course/deleteCourseCoupons'
import deleteCourseLecture from '@services/api/course/deleteCourseLecture'
import deleteCourseLectureContent from '@services/api/course/deleteCourseLectureContent'
import deleteCourseLectureResource from '@services/api/course/deleteCourseLectureResource'
import deleteCoursePricingPolicy from '@services/api/course/deleteCoursePricingPolicy'
import deleteCourseSection from '@services/api/course/deleteCourseSection'
import getAuthorCourses from '@services/api/course/getAuthorCourses'
import getCourse from '@services//api/course/getCourse'
import getCourseCoupons from '@services/api/course/getCourseCoupons'
import getCourseLectureContent from '@services/api/course/getCourseLectureContent'
import getCoursePricingPolicies from '@services/api/course/getCoursePricingPolicies'
import getCourseProgress from '@services/api/course/getCourseProgress'
import getDraftCourse from '@services/api/course/getDraftCourse'
import getLiveCourse from '@services/api/course/getLiveCourse'
import getPublicContentUploadURL from '@services/api/course/getPublicContentUploadURL'
import getPrivateContentUploadURL from '@services/api/course/getPrivateContentUploadURL'
import linkCourseLectureWithContent from '@services/api/course/linkCourseLectureWithContent'
import linkCourseLectureWithResources from '@services/api/course/linkCourseLectureWithResources'
import migrateCourse from '@services/api/course/migrateCourse'
import publishCourse from '@services/api/course/publishCourse'
import updateCourse from '@services/api/course/updateCourse'
import updateCourseLecture from '@services/api/course/updateCourseLecture'
import updateCourseLectureProgress from '@services/api/course/updateCourseLectureProgress'
import updateCourseLecturesOrder from '@services/api/course/updateCourseLecturesOrder'
import updateCoursePresentationalImage from '@services/api/course/updateCoursePresentationalImage'
import updateCoursePresentationalVideo from '@services/api/course/updateCoursePresentationalVideo'
import updateCoursePricingPolicy from '@services/api/course/updateCoursePricingPolicy'
import updateCourseProgress from '@services/api/course/updateCourseProgress'
import updateCourseSection from '@services/api/course/updateCourseSection'
import updateCourseSectionsOrder from '@services/api/course/updateCourseSectionsOrder'
import updateCourseTextContent from '@services/api/course/updateCourseTextContent'
import getFileUploadURL from './getFileUploadURL'

export {
  addCourseCoupon,
  addCourseLecture,
  addCourseSection,
  createCourse,
  createCourseLectureResource,
  createCoursePricingPolicy,
  createCourseTextContent,
  createCourseVideoContent,
  deleteCourseCoupons,
  deleteCourseLecture,
  deleteCourseLectureContent,
  deleteCourseLectureResource,
  deleteCoursePricingPolicy,
  deleteCourseSection,
  getAuthorCourses,
  getCourse,
  getCourseCoupons,
  getCourseLectureContent,
  getCoursePricingPolicies,
  getCourseProgress,
  getDraftCourse,
  getLiveCourse,
  getFileUploadURL,
  getPublicContentUploadURL,
  getPrivateContentUploadURL,
  linkCourseLectureWithContent,
  linkCourseLectureWithResources,
  migrateCourse,
  publishCourse,
  updateCourse,
  updateCourseLecture,
  updateCourseLectureProgress,
  updateCourseLecturesOrder,
  updateCoursePresentationalImage,
  updateCoursePresentationalVideo,
  updateCoursePricingPolicy,
  updateCourseProgress,
  updateCourseSection,
  updateCourseSectionsOrder,
  updateCourseTextContent,
}
